import { useState } from "react";

export function useScheduler() {
  const [events, setEvents] = useState([]);
  const [resources, setResources] = useState([]);
  const [view, setView] = useState("day"); // Default view can be 'day', 'week', 'month', etc.
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [resourceViewMode, setResourceViewMode] = useState("default");

  return {
    events,
    setEvents,
    resources,
    setResources,
    view,
    setView,
    selectedDate,
    setSelectedDate,
    resourceViewMode,
    setResourceViewMode,
  };
}
